/* eslint-disable jsx-a11y/alt-text */
import React, {Component} from "react"
import {ListGroup, Card } from "react-bootstrap"
import "../BodyContent.scss"
import Board from "../../comments/Comments"
import {
    getQuestionsByUser,
    getUserByToken,
    deleteQuestion,
    editQuestion,
} from "../../services/Api"
import {handleUserSetup} from "../../redux/actions/User"
import {connect} from "react-redux"
import {MongoTimeConvert} from "../../converters/timeConverters"
import ContentBar from "./ContentBar"
import EditModal from "../../modals/EditModal"
import QuestionsFeed from "../feed/questions"
import {toast} from "react-toastify"
import "../Responsive.scss"
import { v4 as uuidv4 } from 'uuid';
import MainLoader from "../loader/MainLoader"

const EDUCATE_TOKEN = "educate_token"

class UsersContent extends Component {
    constructor() {
        super()

        this.state = {
            diplay: "none",
            data: [],
            editmodal: false,
            allQuestions: [],
            id: "",
            question: "",
            loading: true
        }

        this.handleEdit = async () => {
            const form = this.formRef.current
            form.validateFields().then(async (values) => {
                const user = {
                    questionId: this.state.id,
                    question: values.inputname,
                }
                const editedQuiz = await editQuestion(user)
                toast(editedQuiz.message)
                this.setState({
                    ...this.state,
                    editmodal: false,
                })
                this.componentDidMount()
            })
        }

        this._onKeyUp = (e) => {
            const data = this.state.allQuestions.filter((item) =>
                item.question
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            )
            this.setState({
                ...this.state,
                data
            })
        }
        this.loadNewQuestions = (params) => {
            console.log(params)
            this.setState({
                ...this.state,
                data: params,
                allQuestions: params,
            })
        }
    }

    showEditModal(id, question) {
        this.setState({
            ...this.state,
            editmodal: true,
            id: id,
            question: question,
        })
    }

    hideEditModal() {
        this.setState({
            ...this.state,
            editmodal: false,
        })
    }

    async deleteQuestion(id) {
        const quizid = {
            id: id,
        }
        const deletedQuestion = await deleteQuestion(quizid)

        toast(deletedQuestion.message)
        this.componentDidMount()
    }

    displayComments(displayComments, id) {
        var newDisplay = ""
        const allquestions = this.state.data
        for (var i = 0; i < allquestions.length; i++) {
            if (allquestions[i]._id === id) {
                if (allquestions[i].displayComments === "block") {
                    newDisplay = "none"
                } else {
                    newDisplay = "block"
                }
                allquestions[i].displayComments = newDisplay
            }
        }
        this.setState({
            ...this.state,
            data: allquestions,
        })
    }

    async checkLogedIn() {
        if (localStorage.getItem(EDUCATE_TOKEN)) {
            const user = await getUserByToken()
            console.log(user)
            this.props.dispatch(handleUserSetup(user.user))
            // this.setState({
            //     id:user.user._id,
            //     displayButtons:'block',
            // })
        } else {
            console.log("User not logged in")
        }
    }

    async componentDidMount() {
        await this.checkLogedIn()
        const userid = {
            id: this.props.currentUser._id,
        }

        const usersQuestions = await getQuestionsByUser(userid)
        console.log(usersQuestions)
        this.setState({
            ...this.state,
            data: usersQuestions,
            allQuestions: usersQuestions,
            loading: false
        })
    }

    formRef = React.createRef()

    render() {
        return (
            <React.Fragment>
                <MainLoader loading={this.state.loading} />
                <div className='contentDiv'>
                    <div className='col-lg-2' id="sidebarContent">
                        <ContentBar LoadQuestion={this.loadNewQuestions}/>
                    </div>
                    <div className='col-lg-6'>
                        <div className='middleSection'>
                            <div className='generalQuestion'>Your Content</div>
                        </div>
                        {this.state.data != null && this.state.data.map((item) => (
                            <div key={uuidv4()} className='questionsCard'>
                                <Card>
                                    <Card.Body>
                                        <Card.Header>
                                            <div className='headerStructure'>
                                                <div className='userNameAndIcon'>
                                                    <div className='imageIcon'>
                                                        <img
                                                            src={require("../../icons/iconuser.png")}
                                                            alt="Icon User"/>
                                                    </div>
                                                    <div className='ownerName'>
                                                        {item.user.fullName}
                                                        <span>
															{" "}
                                                            {MongoTimeConvert(
                                                                item
                                                                    .createdAt
                                                            )}
														</span>{" "}
                                                    </div>
                                                </div>
                                                <div className='editCancelIcons'>
                                                    <div>
                                                        <img
                                                            onClick={() =>
                                                                this.showEditModal(
                                                                    item._id,
                                                                    item.question
                                                                )
                                                            }
                                                            className='cardCloseIcon'
                                                            src={require("../../icons/edit-outlined.svg")}
                                                            alt="Edit outlined icon"/>
                                                    </div>
                                                    <div>
                                                        <img
                                                            onClick={() =>
                                                                this.deleteQuestion(
                                                                    item._id
                                                                )
                                                            }
                                                            className='cardCloseIcon'
                                                            src={require("../../icons/close-outlined.svg")}
                                                            alt=""/>
                                                    </div>
                                                </div>
                                            </div>
                                        </Card.Header>
                                        <Card.Text>{item.question}</Card.Text>
                                    </Card.Body>


                                    <div>
                                        <div className='commentIcon'>
                                            <div
                                                onClick={() =>
                                                    this.displayComments(
                                                        item.displayComments,
                                                        item._id
                                                    )
                                                }
                                                className='imageIcon'
                                            >
                                                <img
                                                    className='cardIcon'
                                                    src={require("../../icons/comment-outlined.svg")}
                                                 alt="Comment Outline SVG"/>
                                                <span>
													{item.comments.length}
												</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div
                                            style={{
                                                display: item.displayComments,
                                            }}
                                        >
                                            <Board
                                                userComment={item.comments}
                                                question={item._id}
                                                addComments={this.addComments}
                                            />
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        ))}
                    </div>
                    <div className='col-lg-2' id='improve-your-feed'>
                        <div className='middleSection' >
                            <ListGroup>
                                <ListGroup.Item className='listFirstItem feedCateGoryName'>
                                    Improve Your feed
                                </ListGroup.Item>
                                <QuestionsFeed/>
                            </ListGroup>
                        </div>
                    </div>
                </div>
                <EditModal
                    name={this.state.question}
                    id={this.state.id}
                    formRef={this.formRef}
                    onSignUpClick={() => this.showEditModal()}
                    visible={this.state.editmodal}
                    onCancel={() => this.hideEditModal()}
                    onCreate={this.handleEdit}
                />
            </React.Fragment>
        )
    }
}

function mapStateToProps({currentUser}) {
    return {
        currentUser: currentUser,
    }
}

export default connect(mapStateToProps)(UsersContent)
